import axios from 'axios'
import ApiError401Handler from './ApiError401Handler'

// eslint-disable-next-line no-undef
const apiUri = process.env.VUE_APP_API_URL + process.env.VUE_APP_VERSION_API

class apiService {
    constructor (axios) {
        this.http = axios.create({ baseURL: apiUri })
        const jwtToken = localStorage.getItem('access_token')
        if (localStorage.getItem('access_token')) {
            this.setAccessToken(jwtToken)
        }
        this.errorHandlers = ApiError401Handler
    }

    setAccessToken (accessToken) {
        this.http.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
    }

    login (user) {
      // eslint-disable-next-line no-undef
        return axios.post(process.env.VUE_APP_API_URL + 'api/auth/login', user)
    }

    register (formData) {
      // eslint-disable-next-line no-undef
        return axios.post(process.env.VUE_APP_API_URL + 'register', formData)
    }

    refreshToken (refreshToken) {
      // eslint-disable-next-line no-undef
        return axios.post(process.env.VUE_APP_API_URL + 'api/auth/refresh', { refresh_token: refreshToken })
    }

    get (url, params = {}) {
        return this.http.get(this.extracted(url), params)
    }

    put (url, formData) {
        return this.http.put(this.extracted(url), formData)
    }

    post (url, formData) {
        this.extracted(url)
        return this.http.post(this.extracted(url), formData)
    }

    extracted (url) {
        let newUrl = url
        if (url[url.length - 1] === '/') {
            newUrl = url.substring(0, url.length - 1)
        }
        return newUrl
    }

    delete (url) {
        return this.http.delete(this.extracted(url))
    }

    handleError (error) {
      return this.errorHandlers.handleError(error)
    }
}

// eslint-disable-next-line new-cap
export const ApiService = new apiService(axios)
